import React from 'react';
import { Button } from '@mui/material';

interface SupportButtonProps {
  buttonText: string;
  onClick: () => void;
  startIcon?: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
  color?: string;
  fullWidth?: boolean;
  disabled?: boolean;
  tabIndex?: number;
}

export const SupportButton = ({
  buttonText,
  onClick,
  startIcon,
  style,
  className,
  color = '#FFFFFF',
  fullWidth = true,
  disabled = false,
  tabIndex,
}: SupportButtonProps) => {
  return (
    <Button
      variant='contained'
      onClick={onClick}
      startIcon={startIcon}
      className={className}
      fullWidth={fullWidth}
      disabled={disabled}
      tabIndex={tabIndex}
      sx={{
        backgroundColor: color,
        padding: '12px 16px',
        color: '#202223',
        fontWeight: 600,
        fontSize: '16px',
        lineHeight: '24px',
        fontFamily: 'Inter',
        borderRadius: '4px',
        textTransform: 'none',
        boxShadow: 'none',
        '&:hover': {
          backgroundColor: color,
          boxShadow: 'none',
        },
        '&:disabled': {
          backgroundColor: '#F2F4F6',
          color: '#4E5968',
          boxShadow: 'none',
        },
        ...style,
      }}
    >
      {buttonText}
    </Button>
  );
};
